module.exports = __webpack_public_path__ + "static/media/Whitney.026ffc40.jpg";